import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: .5em;

    .index-text {
        font-size: 1.1em;
        text-decoration: none;
        display: inline-flex;
        gap: 1em;
        width: 100%;
        align-items: center;
        color: ${variables.colorViolet};
        margin-bottom: 6px;
        font-weight: 500;

        &:last-of-type {
            margin-bottom: 0;
        }

        span {
            color: ${variables.colorViolet} !important;
            font-weight: 700;
        }

        &:hover {
            cursor: pointer;
            text-decoration: underline;
        }
    }

    .index-level {
        display: inline-block;
        margin-bottom: 0;
        margin-top: 0;

        .dot {
            width: 8px;
            height: 8px;
            min-width: 8px;
            min-height: 8px;
            border-radius: 8px;
            display: flex;
            background-color: ${variables.colorDark};
        }

        &-1 {
            margin-left: 0;
            padding-left: 4em;

            .index-element-level-1 {
                .index-text {
                    margin-bottom: 0.5em;
                }
            }
        }

        &-2 {
            margin-left: 2em;
            padding-left: 2em;
        }

        &-3 {
            margin-left: 2em;
            padding-left: 2em;
        }

        &-4 {
            margin-left: 2em;
            padding-left: 2em;
        }
    }

    @media all and (max-width: ${variables.mobileM}) {
        .index-level {
            line-height: 1.2;

            .dot {
                width: 6px;
                height: 6px;
                min-width: 6px;
                min-height: 6px;
            }

            &-1 {
                margin-left: 0;
                padding-left: 0;
            }

            &-2 {
                margin-left: 1em;
                padding-left: 0.5em;
            }

            &-3 {
                margin-left: 2em;
                padding-left: 1em;
            }

            &-4 {
                margin-left: 3em;
                padding-left: 1.5em;
            }
        }
    }
`;
